import { render, staticRenderFns } from "./recaptcha_modal.vue?vue&type=template&id=30cdec3b"
import script from "./recaptcha_modal.vue?vue&type=script&lang=js"
export * from "./recaptcha_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports